<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input size="large" class="w-full" name="Nome" id="Nome" v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Nome')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Nome')
                " val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-user"
            icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Login (sem acentos e sem espaço)</span>
          <vs-input size="large" class="w-full" name="Login" id="Login" v-model="formCadastro.login"
            v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Login')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Login')
                " val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-user"
            icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email</span>
          <vs-input type="email" size="large" class="w-full" name="Email" id="Email" v-model="formCadastro.email"
            v-validate="{ required: true, email: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Email')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Email')
                " val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-mail"
            icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF</span>
          <vs-input size="large" class="w-full" name="CPF" id="CPF" v-model="formCadastro.cpf" val-icon-danger="clear"
            danger-text="Preencha este Campo" v-mask="'###.###.###-##'" icon-pack="feather" icon="icon-user-check"
            icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular</span>
          <vs-input size="large" class="w-full" name="Celular" id="Celular" v-model="formCadastro.celular"
            val-icon-danger="clear" danger-text="Preencha este Campo" v-mask="'(##) #####-####'" icon-pack="feather"
            icon="icon-smartphone" icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Telefone</span>
          <vs-input size="large" class="w-full" name="Telefone" id="Telefone" v-model="formCadastro.telefone"
            val-icon-danger="clear" danger-text="Preencha este Campo" v-mask="'(##) ####-####'" icon-pack="feather"
            icon="icon-phone" icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Data de Nascimento</span>
          <vs-input size="large" class="w-full" name="Data de Nascimento" id="Data de Nascimento"
            v-model="formCadastro.dataNascimento" v-validate="{ date_format: 'dd/MM/yyyy' }" val-icon-danger="clear"
            v-mask="'##/##/####'" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-calendar"
            icon-no-border />
        </div>
      </div>

      <!-----============================ OBS: Precisamos integrar com os correios para que quando jogar o CEP ele venha com o RUA, CIDADE, ESTADO E PAÍS  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CEP</span>
          <vs-input size="large" class="w-full" name="Cep" id="Cep" @keyup.native="keymonitor"
            v-model="formCadastro.cep" val-icon-danger="clear" danger-text="Preencha este Campo" v-mask="'##.###-###'"
            icon-pack="feather" icon="icon-home" icon-no-border />
        </div>
      </div>

      <!-----============================ OBS: API CORREIOS  ==================------->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Endereço</span>
          <vs-input size="large" class="w-full" name="Endereço" id="Endereço" v-model="formCadastro.endereco"
            val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Número</span>
          <vs-input size="large" class="w-full" name="Numero" id="Numero" v-model="formCadastro.numero"
            val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-check-circle"
            icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Complemento</span>
          <vs-input size="large" class="w-full" name="Complemento" id="Complemento" val-icon-danger="clear"
            danger-text="Preencha este Campo" icon-pack="feather" icon="icon-check-circle" icon-no-border
            v-model="formCadastro.complemento" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Bairro</span>
          <vs-input size="large" class="w-full" name="Bairro" id="Bairro" v-model="formCadastro.bairro"
            val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
        </div>
      </div>

      <!-----============================ OBS: API CORREIOS  ==================------->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input size="large" class="w-full" name="Cidade" id="Cidade" v-model="formCadastro.cidade"
            val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input size="large" class="w-full" name="Estado" id="Estado" v-model="formCadastro.estado"
            val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Perfil</span>
          <v-select :options="perfis" name="Perfil" id="Perfil" v-model="formCadastro.idPerfil"></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Conta Demo?</span>
          <vs-switch color="success" v-model="formCadastro.isContaExemplo" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div v-if="!this.dados.idUsuario" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Senha de Acesso</span>
          <vs-input size="large" class="w-full" name="Senha" id="Senha" v-model="formCadastro.senha"
            v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Senha')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Senha')
                " val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-user"
            icon-no-border />
        </div>
      </div>
      <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
        style="height: auto !important">
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit variant="success" :edit="this.dados.idUsuario == null ? false : true" :aguarde="aguardeCadastro">
          </BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../services";
import BotaoSubmit from "../../../components/BotaoSubmit";
import utilsList from "../../../utils/list";
import cpfCnpj from "../../../services/cpfCnpj";
import dataFunctions from "../../../utils/dateConversion";
import moment from "moment";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      distribuidores: [],
      perfis: [],
      fornecedores: [],
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idUsuario: null,
        status: true,
        nome: null,
        email: null,
        cpf: null,
        celular: null,
        telefone: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "BR",
        idDistribuidor: null,
        idPerfil: null,
        idFornecedor: null,
        login: null,
        isContaExemplo: false,
      },
    };
  },
  methods: {
    preencheForm() {
      console.log("preencheform");
      if (this.dados.idUsuario) {
        this.formCadastro.idUsuario = this.dados.idUsuario;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.consultor = this.dados.consultor;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cpf = this.dados.cpf;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.dataNascimento = moment(this.dados.dataNascimento)
          .utc()
          .format("DD/MM/YYYY");
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.pais = this.dados.pais;
        this.formCadastro.login = this.dados.login;
        this.formCadastro.isContaExemplo = !!this.dados.isContaExemplo;
        this.formCadastro.idDistribuidor = {
          id: this.dados.idDistribuidor,
          label: this.dados.distribuidor,
        };
        this.formCadastro.idPerfil = {
          id: this.dados.idPerfil,
          label: this.dados.perfil,
        };
        this.formCadastro.idFornecedor = {
          id: this.dados.idFornecedor,
          label: this.dados.fornecedor,
        };
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idUsuario;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idUsuario) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Usuário Adicionado com sucesso";
      }

      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: `Este CPF não é válido`,
          color: "danger",
        });
        return;
      }

      var objSend = { ...this.formCadastro };
      objSend.dataNascimento = dataFunctions.convertDateToISO(
        objSend.dataNascimento
      );
      if (objSend.idPerfil) objSend.idPerfil = objSend.idPerfil.id;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Usuario", action, objSend)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    keymonitor: function (event) {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace(".", "").replace("-", "");
        service
          .post("g", "BuscaCEP", {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Não Foi possível encontrar o cep",
              color: "danger",
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        isContaExemplo: true,
        nome: null,
        email: null,
        cpf: null,
        celular: null,
        telefone: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "BR",
        idDistribuidor: null,
        idPerfil: null,
        idFornecedor: null,
        login: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.buscaDadosSelects("perfis", "perfis", "nomePerfil", "idPerfil");

    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
